import React, { Fragment, useState } from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap';
import { H5, LI, UL, Btn } from '../../../../AbstractElements';
import Image from '../../../../CommonElements/Media';
import { LatestPhotosData } from '../../../../Data/Bonus-ui/Data';
import { Latest_Photos } from '../../../../Constant';
import { ChevronDown, ChevronUp } from 'react-feather';

const LatestPhotos = () => {
  const [isShow, setIsShow] = useState(true);

  return (
    <Fragment>
      <Card>
        <CardHeader>
          <H5 className='p-0 mb-0'>
            <Btn
              color='transparent btn-link accordion-icon '
              onClick={() => {
                setIsShow(!isShow);
              }}>
              {Latest_Photos} {!isShow && <ChevronDown />}
              {isShow && <ChevronUp />}
            </Btn>
          </H5>
        </CardHeader>
        <div className={`collapse ${isShow ? 'show' : ''}`} id='collapseicon4' data-parent='#accordion' aria-labelledby='collapseicon4'>
          <CardBody className='card-body photos filter-cards-view'>
            <UL className='simple-list flex-row'>
              {LatestPhotosData.map((item) => (
                <LI key={item.id} className='rounded-10'>
                  <div className='latest-post'>
                    <Image className='img-fluid' alt='' src={item.img} />
                  </div>
                </LI>
              ))}
            </UL>
          </CardBody>
        </div>
      </Card>
    </Fragment>
  );
};

export default LatestPhotos;
